export const formatDate = (date) =>{
    let _date = new Date(date)
    let result = _date.getDate() +" "  + _date.toLocaleString('en-EU',{month: 'short'}) + " " + _date.getFullYear()
    //let result =  _date.getFullYear()+" "  + _date.toLocaleString('en-EU',{month: 'short'}) + " "  + _date.getDay()
    return  result;
}